import { DishCardDisplayMode } from '../../checkout/types';
import {
  DISH_CARD_CLASSES,
  DISH_IMAGE_ZOOM,
  IMAGE_HEIGHT_CAROUSEL,
  IMAGE_HEIGHT_GRID,
  IMAGE_WIDTH_CAROUSEL,
  IMAGE_WIDTH_GRID,
} from './consts';
import { DishImageAspectRatio } from './MealPlanDishImage';

interface DishCardImageGeometryParams {
  displayMode: DishCardDisplayMode;
  showShef: boolean;
}

export interface DishCardImageGeometry {
  /** Thumbor request size; scaled by `zoom` inside `MealPlanDishImage`. */
  width: number;
  height: number;
  zoom: number;
  /** Only set for grid cards, which size from a fluid width instead of a fixed height. */
  aspectRatio?: DishImageAspectRatio;
  cardClassName?: string;
  imageClassName?: string;
}

/**
 * Resolves every dimension the large dish card needs.
 *
 * Grid cards get an aspect ratio because their width is fluid; carousel cards are a fixed 308px wide
 * and so get explicit heights.
 */
export const getDishCardImageGeometry = ({
  displayMode,
  showShef,
}: DishCardImageGeometryParams): DishCardImageGeometry => {
  if (displayMode === DishCardDisplayMode.Grid) {
    return {
      width: IMAGE_WIDTH_GRID,
      height: IMAGE_HEIGHT_GRID,
      zoom: DISH_IMAGE_ZOOM,
      aspectRatio: DishImageAspectRatio.Tall,
      imageClassName: 'max-h-[400px]',
    };
  }

  return {
    width: IMAGE_WIDTH_CAROUSEL,
    height: IMAGE_HEIGHT_CAROUSEL,
    zoom: DISH_IMAGE_ZOOM,
    cardClassName: showShef ? DISH_CARD_CLASSES.cardWithShef : DISH_CARD_CLASSES.card,
    imageClassName: DISH_CARD_CLASSES.image,
  };
};
